export * from './my-discoveries.component';
export * from './account-list-detail/account-list-detail.component';
export * from './album-list-detail/album-list-detail.component';
export * from './artist-list-detail/artist-list-detail.component';
export * from './follow/follow.component';
export * from './playlist-list-detail/playlist-list-detail.component';
export * from './song-list-detail/song-list-detail.component';



// WEBPACK FOOTER //
// ./src/app/my-discoveries/index.ts